import { render } from "./CartPopover.vue?vue&type=template&id=242f71aa"
import script from "./CartPopover.vue?vue&type=script&lang=js"
export * from "./CartPopover.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__